//accion para indicar la aparicion o no de un mensaje de error al hacer el login o el registro
export const openMessageError = (dispatch, openMessage) => {
  dispatch({
    type: "OPEN_SNACKBAR",
    openMessage: openMessage
  });
};
